export default __webpack_public_path__ + "static/wilson-tan-peppercloud-customer-d1569c135190888e4af178bd182252fa.jpg";